(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.infra-company.pdf.view
  (:require
   [clojure.string :as s]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view
    :refer [column columns columns-2-to-1]]
   [frontend.ui.component.lp-portal.page.pdf.view
    :as page]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view
    :refer [stacked-text-group]]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.page.lp-portal.report.pdf.view :refer [report]]
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [potpuri.core :as potpuri]
   [clojure.string :as string]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]))

(defn- latest-development-figures-board
  [board]
  (let [[section-title board-members] (:figures board)]
    (card
     section-title
     (map (fn [board-member]
            (let [[member-name & member-title-strs] (s/split board-member ", ")]
              {:stack  [member-name
                        {:text  (s/join ", " member-title-strs)
                         :color (theme/color [:pdf :stack :value-list])}]
               :margin [0 0 0 15]}))
          board-members))))

(defn overview-pages
  [report-data]
  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title (:holding-name report-data) :toc-item true})
    (columns-2-to-1
     (column/column
      (card
       "Case Overview"
       (text-content/rich-content (->> report-data
                                       :overview
                                       :case-overview-text
                                       :rich-content)))
      (card
       "Market Development"
       (text-content/rich-content (->> report-data
                                       :overview
                                       :market-development-text
                                       :rich-content))))
     {:margin [0 15 0 0]
      :stack  (->> report-data
                   :overview
                   :overview-figures
                   :figures
                   (map
                    (fn [[label value]]
                      (stacked-text-group label value))))}))
   (page/page
    (page/third-column-background)
    (page/page-title {:page-title (:holding-name report-data)})
    (columns-2-to-1
     (card "Latest Development"
           (text-content/rich-content (->> report-data
                                           :overview
                                           :latest-development-text
                                           :rich-content)))
     (latest-development-figures-board (-> report-data
                                           :overview
                                           :board))))])


(defn- financials
  [report-data]
  (page/page
   (page/page-title {:page-title (:holding-name report-data)})
   (columns
    (card "Financial Performance"
          (text-content/rich-content (-> report-data
                                         :financial-performance-text
                                         :rich-content)))
    [(card
      "Financials"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge
                                     (-> report-data
                                         :financials
                                         :figures)
                                     {:chart {:width  600
                                              :height 240}}))
       :width 400}
      (text-content/optional-footer (:financials report-data)) ; is this ever used?
     )
     (card
      "Net Debt"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge (-> report-data
                                                            :net-debt
                                                            :figures)
                                                        {:chart {:width  600
                                                                 :height 240}}))
       :width 400}
      (text-content/optional-footer (:net-debt report-data)) ; is this ever used?
     )])))

(defn- value-creation-plan-page
  [report-data]
  (page/page
   (page/page-title {:page-title (:holding-name report-data)})
   (column
    (card
     "Value creation plan & exit vision"
     (text-content/rich-content (-> report-data
                                    :value-creation-plan-text
                                    :rich-content))))))

(defn- valuation
  [valuation]
  (card
   "Valuation"
   {:svg   (chart-view/chart-svg "highcharts" (:figures valuation))
    :width 350}
   (text-content/optional-footer valuation)))

(defn- valuation-ownership-page
  [company-name valuation-data valuation-text]
  (page/page
   (page/page-title {:page-title company-name})
   (columns
    (column/column
     (card
      "Valuation principles"
      (text-content/rich-content (-> valuation-text
                                     :rich-content))))
    (column/column
     (valuation valuation-data)))))

(defn- ownership-page
  [company-name ownership-data distribution-yield]
  (page/page
   (page/page-title {:page-title company-name})
   (column/columns
    (column/column
     (card "Distribution yield"
           {:svg   (chart-view/chart-svg "highcharts"
                                         (potpuri/deep-merge
                                          (:figures distribution-yield)
                                          {:chart {:width  500
                                                   :height 400}}))
            :width 350}
           (text-content/optional-footer distribution-yield)))
    (column/column
     (table/dynamic-table-card "Ownership"
                               ownership-data
                               {:odd-color     (theme/color [:pdf :table :odd-color])
                                :even-color    (theme/color [:pdf :table :even-color])
                                :heading-color (theme/color [:pdf :table
                                                             :heading-color])}
                               {:margin-top 12})))))

(defn holding-pages
  "PDFMake page definitions for Private Equity holding Company to be passed to
  `frontend.ui.page.lp-portal.report.pdf.view/report` in production. See `company-pages`."
  [{:keys [holding-name
           valuation
           valuation-text
           distribution-yield
           ownership]
    :as   report-data}]
  (concat
   (overview-pages report-data)
   [(financials report-data)
    (value-creation-plan-page report-data)
    (valuation-ownership-page holding-name valuation valuation-text)
    (ownership-page holding-name ownership distribution-yield)]))

(defn company
  "View for a LP Portal report that is solely based on Private Equity holding Company (no fund).
  This function will likely only be used by a Devcard for showcase purposes. See `company-pages`."
  [{:keys [reporting-period reference-date] :as view-data}]
  (report view-data (holding-pages view-data) "PE holding company" reporting-period reference-date))
